<template>
  <div>
    <lite-embed-instructions v-if="isLiteSubscriber" />
    <embed-instructions v-else />
  </div>
</template>

<script>
import EmbedInstructions from '@/components/Cancellation/EmbedCode/EmbedInstructions.vue';
import LiteEmbedInstructions from '@/components/Cancellation/EmbedCode/LiteEmbedInstructions.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'EmbedInstructionsWrapper',
  components: {
    EmbedInstructions,
    LiteEmbedInstructions,
  },
  computed: {
    ...mapGetters(['isLiteSubscriber']),
  },
};
</script>
